(function () {
  function init(root) {
    if (!root || root.dataset.crtInit === '1') return;
    root.dataset.crtInit = '1';

    var list = root.querySelector('[data-crt-list]');
    var empty = root.querySelector('[data-crt-empty]');
    var summary = root.querySelector('[data-crt-summary]');
    var loadMoreBtn = root.querySelector('[data-crt-load-more]');
    var loadWrap = root.querySelector('[data-crt-load-wrap]');
    var textModal = root.querySelector('[data-crt-text-modal]');
    var textModalAuthor = root.querySelector('[data-crt-text-modal-author]');
    var textModalStars = root.querySelector('[data-crt-text-modal-stars]');
    var textModalBody = root.querySelector('[data-crt-text-modal-body]');
    var textModalCloseEls = root.querySelectorAll('[data-crt-text-modal-close]');
    var textModalEscapeHandler = function (e) {
      if (e.key === 'Escape' && textModal && !textModal.hidden) closeReviewTextModal();
    };

    var apiUrl = (root.getAttribute('data-api-base-url') || 'https://amc-ew.aogen.com.au').trim();
    var shopDomain = root.getAttribute('data-shop-domain') || root.getAttribute('data-shop-domain-fallback') || '';
    var locationId = root.getAttribute('data-location-id') || '';
    var minRating = parseFloat(root.getAttribute('data-min-rating') || '1');
    var showDate = root.getAttribute('data-show-date') === 'true';
    var showPhoto = root.getAttribute('data-show-photo') !== 'false';
    var reviewsMode = (root.getAttribute('data-reviews-mode') || 'google').trim();
    var requireVerifiedOnly = root.getAttribute('data-require-verified-only') === 'true';
    var pageWorkshopType = (root.getAttribute('data-workshop-type') || '').trim();
    var sortOrder = root.getAttribute('data-sort-order') || 'newest_first';
    var fallbackUrl = root.getAttribute('data-fallback-url') || '';
    var rowsPerLoad = parseInt(root.getAttribute('data-rows-per-load'), 10) || 8;
    var maxReviews = parseInt(root.getAttribute('data-max-reviews'), 10) || 24;

    var apiWorkshopTypeQueryMap = {};
    try {
      apiWorkshopTypeQueryMap = JSON.parse(root.getAttribute('data-api-workshop-type-query-map') || '{}');
    } catch (e) {
      apiWorkshopTypeQueryMap = {};
    }

    var allReviews = [];
    var seenReviewKeys = {};
    var fallbackSnapshot = [];
    var fallbackLoaded = false;
    var fallbackReviewKeySeq = 0;
    var visibleCount = rowsPerLoad;
    var allReviewsOffset = 0;
    var ownReviewsOffset = 0;
    var ownReviewsExhausted = false;
    var hasMoreReviews = true;
    var isFetching = false;
    var typeScopedAggregateAvg = null;
    var shopWideAggregateAvg = null;
    var typeScopedAggregateCount = null;
    var shopWideAggregateCount = null;
    var apiTotalCount = null;
    var headerPrimedCount = null;
    var headerPrimedAvg = null;
    var expandTextStore = {};
    var expandTextSeq = 0;
    var googleIconMarkup = root.querySelector('[data-crt-google-icon-markup]');
    var googleIcon = googleIconMarkup ? googleIconMarkup.innerHTML.trim() : '';

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (ch) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
      });
    }

    function buildUrl(endpoint) {
      if (/^https?:\/\//i.test(endpoint || '')) return endpoint;
      return apiUrl.replace(/\/$/, '') + '/' + String(endpoint || '').replace(/^\//, '');
    }

    function apiWorkshopQueryKey(canonical) {
      var c = String(canonical || '').trim();
      if (!c) return '';
      var lower = c.toLowerCase();
      var mapped = apiWorkshopTypeQueryMap[c] != null ? apiWorkshopTypeQueryMap[c] : apiWorkshopTypeQueryMap[lower];
      if (mapped != null && String(mapped).trim() !== '') return String(mapped).trim();
      return lower;
    }

    function normalizeType(raw) {
      var t = String(raw || '').toLowerCase().trim();
      if (t.indexOf('mosaic') > -1) return 'mosaic';
      if (t.indexOf('resin') > -1) return 'resin';
      if (t.indexOf('ceramic') > -1) return 'ceramic';
      if (t.indexOf('flower') > -1) return 'flower';
      return 'all';
    }

    function formatMonthYear(unix) {
      var n = Number(unix);
      if (!n || !Number.isFinite(n)) return '';
      if (n > 1e12) n = Math.floor(n / 1000);
      var d = new Date(n * 1000);
      if (Number.isNaN(d.getTime())) return '';
      try {
        return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      } catch (e) {
        return '';
      }
    }

    function formatRelativeReviewTime(unix) {
      return formatMonthYear(unix);
    }

    function resolvePhotoUrl(item) {
      if (!item || typeof item !== 'object') return '';
      var fields = [
        item.author_photo,
        item.profile_photo_url,
        item.profile_photo,
        item.author_image,
        item.avatar_url
      ];
      for (var i = 0; i < fields.length; i++) {
        var raw = fields[i];
        if (!raw) continue;
        if (typeof raw === 'string' && raw.trim()) return raw.trim();
        if (typeof raw === 'object' && raw.value != null && String(raw.value).trim()) {
          return String(raw.value).trim();
        }
      }
      return '';
    }

    function reviewDedupeKey(item, mapped) {
      var id = item && (item.id != null ? item.id : item.review_id != null ? item.review_id : item.uuid != null ? item.uuid : item.external_id != null ? item.external_id : '');
      if (id !== '' && id != null) return 'id:' + String(id);
      var a = mapped && mapped.author_name ? String(mapped.author_name) : '';
      var tm = mapped && mapped.time ? String(mapped.time) : '';
      var tx = mapped && mapped.text ? String(mapped.text).slice(0, 120) : '';
      return 'sig:' + a + '|' + tm + '|' + tx;
    }

    function mapGoogleItem(item) {
      var rawT = item.review_time !== undefined && item.review_time !== null ? item.review_time : item.time;
      var rel = item.relative_time || item.time_description || '';
      if (typeof rawT === 'string' && String(rawT).trim() && isNaN(parseInt(rawT, 10))) {
        rel = rel || String(rawT).trim();
        rawT = 0;
      }
      var row = {
        rating: Number(item.rating || 0),
        workshop_type: (function () {
          if (item.workshop_type) return normalizeType(item.workshop_type);
          var types = item.workshop_types;
          if (Array.isArray(types) && types.length) return normalizeType(types[0]);
          return 'all';
        })(),
        author_name: item.author_name || item.author || 'Anonymous',
        author_photo: resolvePhotoUrl(item),
        author_url: item.author_url || '',
        review_url: item.review_url || '',
        text: item.text || item.review_text || '',
        time: parseInt(rawT, 10) || 0,
        timestamp: item.timestamp,
        relative_time: rel,
        source: (item.source || item.provider || 'google').toLowerCase(),
        provider: String(item.provider || item.source || 'google').toLowerCase(),
        verified_purchase: Boolean(item.verified_purchase || item.purchase_verified)
      };
      row._key = reviewDedupeKey(item, row);
      return row;
    }

    function shuffleArray(arr) {
      if (sortOrder !== 'shuffle') return arr;
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i];
        a[i] = a[j];
        a[j] = t;
      }
      return a;
    }

    function buildDisplayList(reviews) {
      var rated = (Array.isArray(reviews) ? reviews : []).filter(function (r) {
        var meetsRating = Number(r.rating || 0) >= minRating;
        if (!meetsRating) return false;
        if (reviewsMode === 'workshop' && requireVerifiedOnly) {
          return r.source !== 'site' || Boolean(r.verified_purchase);
        }
        return true;
      });
      if (reviewsMode === 'workshop' && pageWorkshopType) {
        var pri = rated.filter(function (r) { return r.workshop_type === pageWorkshopType; });
        if (pri.length) return pri;
      }
      return rated;
    }

    function filteredReviewCount() {
      return buildDisplayList(allReviews).length;
    }

    function needsMoreInitialReviews() {
      return filteredReviewCount() < visibleCount && hasMoreReviews && allReviews.length < maxReviews;
    }

    function finishBatchOrContinue(madeProgress) {
      if (needsMoreInitialReviews() && madeProgress !== false && hasMoreReviews && allReviews.length < maxReviews) {
        /* Clear flag before chaining — fetchNextBatch() early-returns while isFetching. */
        isFetching = false;
        fetchNextBatch();
        return;
      }
      isFetching = false;
      if (list) list.classList.remove('is-updating');
      syncLoadUi();
      if (!allReviews.length && !hasMoreReviews) maybeApplyFallback();
    }

    function applyHeaderPrimeFromPayload(payload, aggregate) {
      var aggregateAvg = aggregate && aggregate.avg_rating != null ? Number(aggregate.avg_rating) : NaN;
      var aggregateCount = aggregate && aggregate.review_count != null ? Number(aggregate.review_count) : NaN;
      var total = payload && payload.total != null ? Number(payload.total) : NaN;
      if (Number.isFinite(aggregateAvg)) headerPrimedAvg = aggregateAvg;
      if (Number.isFinite(total) && total > 0) headerPrimedCount = Math.round(total);
      else if (Number.isFinite(aggregateCount) && aggregateCount > 0) headerPrimedCount = Math.round(aggregateCount);
    }

    function primeHeaderAggregate(done) {
      if (!shopDomain) {
        if (done) done();
        return;
      }
      fetchReviews({ workshopTypeKey: '', offset: 0, limit: 1, headerOnly: true }, function () {
        if (done) done();
      });
    }

    function fetchReviews(options, done) {
      if (!shopDomain) {
        done([]);
        return;
      }
      var params = new URLSearchParams();
      params.set('shop_domain', shopDomain);
      if (locationId && locationId !== 'all') params.set('location_id', locationId);
      var canonicalWT = options.workshopTypeKey != null ? String(options.workshopTypeKey).trim() : '';
      var queryWT = canonicalWT ? apiWorkshopQueryKey(canonicalWT) : '';
      if (queryWT) params.set('workshop_type', queryWT);
      if (reviewsMode === 'workshop') {
        params.set('status', 'approved');
        params.set('include_google', 'true');
        params.set('include_site', 'true');
      }
      params.set('sort', sortOrder);
      params.set('limit', String(options.limit));
      params.set('offset', String(options.offset));
      fetch(buildUrl('/api/public/reviews') + '?' + params.toString())
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('Request failed')); })
        .then(function (payload) {
          var listData = Array.isArray(payload) ? payload : (payload.reviews || []);
          var aggregate = payload && payload.aggregate ? payload.aggregate : null;
          if (options.headerOnly) {
            if (payload && payload.total != null && !canonicalWT) apiTotalCount = Number(payload.total);
            applyHeaderPrimeFromPayload(payload, aggregate);
            if (aggregate && aggregate.avg_rating != null && Number.isFinite(Number(aggregate.avg_rating))) {
              shopWideAggregateAvg = Number(aggregate.avg_rating);
            }
            if (aggregate && aggregate.review_count != null && Number.isFinite(Number(aggregate.review_count))) {
              shopWideAggregateCount = Number(aggregate.review_count);
            }
            renderSummary();
            done([]);
            return;
          }
          if (payload && payload.total != null && !canonicalWT) apiTotalCount = Number(payload.total);
          var aggregateAvg = aggregate && aggregate.avg_rating != null ? Number(aggregate.avg_rating) : NaN;
          var aggregateCount = aggregate && aggregate.review_count != null ? Number(aggregate.review_count) : NaN;
          if (Number.isFinite(aggregateAvg)) {
            if (canonicalWT && String(canonicalWT).trim() !== '') {
              typeScopedAggregateAvg = aggregateAvg;
            } else {
              shopWideAggregateAvg = aggregateAvg;
            }
          }
          if (Number.isFinite(aggregateCount)) {
            if (canonicalWT && String(canonicalWT).trim() !== '') {
              typeScopedAggregateCount = aggregateCount;
            } else {
              shopWideAggregateCount = aggregateCount;
            }
          }
          var hint = options.workshopTypeHint != null && String(options.workshopTypeHint).trim() !== ''
            ? options.workshopTypeHint
            : canonicalWT;
          var mapped = listData.map(mapGoogleItem).map(function (r) {
            if (!hint || hint === 'all' || r.workshop_type !== 'all') return r;
            var next = Object.assign({}, r);
            next.workshop_type = normalizeType(hint);
            return next;
          });
          done(mapped);
          renderSummary();
        })
        .catch(function () {
          if (empty) {
            empty.hidden = false;
            empty.textContent = 'Unable to load reviews right now.';
          }
          done([]);
        });
    }

    function loadFallbackSnapshot(done) {
      if (fallbackLoaded) {
        if (done) done();
        return;
      }
      if (!fallbackUrl) {
        fallbackLoaded = true;
        if (done) done();
        return;
      }
      fetch(fallbackUrl)
        .then(function (res) { return res.ok ? res.json() : []; })
        .then(function (listData) {
          fallbackSnapshot = Array.isArray(listData) ? listData.map(mapGoogleItem) : [];
          fallbackLoaded = true;
          if (done) done();
        })
        .catch(function () {
          fallbackLoaded = true;
          if (done) done();
        });
    }

    function appendReviews(reviews) {
      (Array.isArray(reviews) ? reviews : []).forEach(function (r) {
        if (!r || typeof r !== 'object') return;
        var k = r._key != null && String(r._key).trim() !== '' ? String(r._key) : '';
        if (!k) k = 'fb:' + (++fallbackReviewKeySeq);
        r._key = k;
        if (seenReviewKeys[k]) return;
        seenReviewKeys[k] = true;
        allReviews.push(r);
      });
      renderRows({ appendOnly: true });
    }

    function starsHtml(rating, extraClass) {
      var full = Math.max(0, Math.min(5, Math.round(Number(rating || 0))));
      var cls = 'crt-row__stars' + (extraClass ? ' ' + extraClass : '');
      var html = '<span class="' + cls + '" role="img" aria-label="' + full + ' out of 5 stars">';
      for (var i = 1; i <= 5; i++) {
        html += '<span class="crt-row__star' + (i <= full ? ' is-filled' : '') + '" aria-hidden="true">\u2605</span>';
      }
      html += '</span>';
      return html;
    }

    function computeAvgFromReviews(list) {
      var rated = (Array.isArray(list) ? list : []).filter(function (r) {
        return Number(r.rating || 0) >= minRating;
      });
      if (!rated.length) return null;
      return rated.reduce(function (sum, r) { return sum + Number(r.rating || 0); }, 0) / rated.length;
    }

    function pickHeaderAggregate() {
      var hdr = null;
      if (headerPrimedAvg != null && Number.isFinite(headerPrimedAvg)) hdr = headerPrimedAvg;
      if (reviewsMode === 'workshop' && pageWorkshopType) {
        if (typeScopedAggregateAvg != null && Number.isFinite(typeScopedAggregateAvg)) hdr = typeScopedAggregateAvg;
        else if (hdr == null && shopWideAggregateAvg != null && Number.isFinite(shopWideAggregateAvg)) hdr = shopWideAggregateAvg;
      } else {
        if (shopWideAggregateAvg != null && Number.isFinite(shopWideAggregateAvg)) hdr = shopWideAggregateAvg;
        else if (typeScopedAggregateAvg != null && Number.isFinite(typeScopedAggregateAvg)) hdr = typeScopedAggregateAvg;
      }
      if (hdr != null && Number.isFinite(hdr)) return hdr;
      return computeAvgFromReviews(allReviews);
    }

    function formatReviewCount(n) {
      try {
        return Number(n).toLocaleString('en-US');
      } catch (e) {
        return String(n);
      }
    }

    function pickHeaderCount() {
      if (headerPrimedCount != null && Number.isFinite(headerPrimedCount) && headerPrimedCount > 0) {
        return Math.round(headerPrimedCount);
      }
      if (apiTotalCount != null && Number.isFinite(apiTotalCount) && apiTotalCount > 0) {
        return Math.round(apiTotalCount);
      }
      if (shopWideAggregateCount != null && Number.isFinite(shopWideAggregateCount) && shopWideAggregateCount > 0) {
        return Math.round(shopWideAggregateCount);
      }
      if (!pageWorkshopType && typeScopedAggregateCount != null && Number.isFinite(typeScopedAggregateCount) && typeScopedAggregateCount > 0) {
        return Math.round(typeScopedAggregateCount);
      }
      return filteredReviewCount();
    }

    function avatarHtml(review) {
      var name = review.author_name || 'Anonymous';
      var initial = escapeHtml(String(name).trim().charAt(0).toUpperCase() || 'A');
      var photo = review.author_photo ? String(review.author_photo).trim() : '';
      if (showPhoto && photo) {
        return (
          '<div class="crt-row__avatar">' +
            '<img src="' + escapeHtml(photo) + '" alt="' + escapeHtml(name) + '" width="40" height="40" loading="lazy" decoding="async" referrerpolicy="no-referrer" class="crt-row__avatar-img" data-crt-avatar-img>' +
          '</div>'
        );
      }
      return '<div class="crt-row__avatar"><span class="crt-row__avatar-fallback" aria-hidden="true">' + initial + '</span></div>';
    }

    function renderRowHtml(review) {
      var full = Math.max(0, Math.min(5, Number(review.rating || 0)));
      var reviewTextRaw = review.text != null ? String(review.text) : '';
      var dateLabel = showDate ? formatMonthYear(review.time || review.timestamp) : '';
      if (!dateLabel && review.relative_time) dateLabel = String(review.relative_time);
      var dateHtml = dateLabel
        ? '<time class="crt-row__date">' + escapeHtml(dateLabel) + '</time>'
        : '';
      var bodyHtml = '';
      if (reviewTextRaw.trim()) {
        bodyHtml =
          '<div class="crt-row__body">' +
            '<p class="crt-row__text crt-row__text--clamp" data-crt-text>' + escapeHtml(reviewTextRaw) + '</p>' +
            '<button type="button" class="crt-row__show-more" data-crt-expand hidden>Show more</button>' +
          '</div>';
      }
      return (
        '<article class="crt-row crt-row--enter" data-crt-row data-crt-rating="' + escapeHtml(String(full)) + '" role="listitem">' +
          '<div class="crt-row__person">' +
            avatarHtml(review) +
            '<div class="crt-row__identity">' +
              '<p class="crt-row__author">' + escapeHtml(review.author_name || 'Anonymous') + '</p>' +
              dateHtml +
            '</div>' +
          '</div>' +
          bodyHtml +
        '</article>'
      );
    }

    function syncTextClamps(scope) {
      if (!scope) return;
      scope.querySelectorAll('[data-crt-row]').forEach(function (row) {
        var textEl = row.querySelector('[data-crt-text]');
        var btn = row.querySelector('[data-crt-expand]');
        if (!textEl || !btn) return;
        textEl.classList.add('crt-row__text--clamp');
        textEl.classList.remove('is-expanded');
        btn.hidden = true;
        btn.textContent = 'Show more';
        btn.setAttribute('aria-expanded', 'false');
        // Measure after clamp is applied
        requestAnimationFrame(function () {
          var overflows = textEl.scrollHeight > textEl.clientHeight + 1;
          btn.hidden = !overflows;
        });
      });
    }

    function openReviewTextModal(author, text, rating) {
      if (!textModal || !textModalBody) return;
      var a = author != null ? String(author) : '';
      if (textModalAuthor) {
        textModalAuthor.textContent = a;
        textModalAuthor.hidden = !a.trim();
      }
      var r = Math.max(0, Math.min(5, parseFloat(String(rating || '').trim())));
      if (textModalStars) {
        if (Number.isFinite(r) && r > 0) {
          var fullStars = Math.floor(r);
          textModalStars.textContent = '\u2605'.repeat(fullStars) + '\u2606'.repeat(5 - fullStars);
          textModalStars.hidden = false;
        } else {
          textModalStars.textContent = '';
          textModalStars.hidden = true;
        }
      }
      textModalBody.textContent = text != null ? String(text) : '';
      textModal.removeAttribute('hidden');
      textModal.classList.add('is-open');
      document.addEventListener('keydown', textModalEscapeHandler);
    }

    function closeReviewTextModal() {
      if (!textModal) return;
      document.removeEventListener('keydown', textModalEscapeHandler);
      textModal.classList.remove('is-open');
      textModal.setAttribute('hidden', '');
      if (textModalBody) textModalBody.textContent = '';
      if (textModalAuthor) {
        textModalAuthor.textContent = '';
        textModalAuthor.hidden = true;
      }
      if (textModalStars) {
        textModalStars.textContent = '';
        textModalStars.hidden = true;
      }
    }

    function skeletonHtml(count) {
      var html = '';
      for (var i = 0; i < count; i++) {
        html +=
          '<article class="crt-row crt-row--skeleton" aria-hidden="true">' +
            '<div class="crt-row__person">' +
              '<div class="crt-row__avatar"><span class="crt-row__avatar-fallback">&nbsp;</span></div>' +
              '<div class="crt-row__identity">' +
                '<p class="crt-row__author">&nbsp;</p>' +
                '<p class="crt-row__date">&nbsp;</p>' +
              '</div>' +
            '</div>' +
            '<p class="crt-row__text">&nbsp;</p>' +
          '</article>';
      }
      return html;
    }

    function renderSummary() {
      if (!summary) return;
      var reviewCount = pickHeaderCount();
      var hdr = pickHeaderAggregate();
      if (!reviewCount || hdr == null || !Number.isFinite(hdr)) {
        summary.hidden = true;
        summary.innerHTML = '';
        return;
      }
      var avg = Number(hdr).toFixed(2);
      summary.innerHTML =
        '<svg class="crt-summary__star" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
          '<path fill="currentColor" d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.9l-4.94 2.6.94-5.49-4-3.9 5.53-.8L10 1.5z"/>' +
        '</svg>' +
        '<div class="crt-summary__meta">' +
          '<span class="crt-summary__rating">' + escapeHtml(avg) + '</span>' +
          '<span class="crt-summary__dot" aria-hidden="true"></span>' +
          '<span class="crt-summary__count">' + escapeHtml(formatReviewCount(reviewCount)) + ' review' + (reviewCount === 1 ? '' : 's') + '</span>' +
        '</div>';
      summary.hidden = false;
      summary.setAttribute('data-crt-avg', avg);
      summary.setAttribute('data-crt-count', String(Math.round(reviewCount)));
      document.dispatchEvent(
        new CustomEvent('amc:reviews-aggregate', {
          detail: {
            avg: Number(avg),
            count: Math.round(reviewCount),
            avgLabel: avg,
            countLabel: formatReviewCount(reviewCount)
          }
        })
      );
    }

    function syncLoadUi(filteredCount) {
      var total = typeof filteredCount === 'number' ? filteredCount : buildDisplayList(allReviews).length;
      var headerCount = pickHeaderCount();
      var displayCount = headerCount > 0 ? headerCount : Math.min(total, maxReviews);
      var cappedTotal = Math.min(total, maxReviews);
      var canShowMoreLocal = cappedTotal > visibleCount;
      var canFetchMore = hasMoreReviews && allReviews.length < maxReviews;
      var canLoadMore = visibleCount < maxReviews && (canShowMoreLocal || canFetchMore);
      if (loadWrap) loadWrap.hidden = cappedTotal === 0 && !isFetching;
      if (loadMoreBtn) {
        loadMoreBtn.textContent = 'Show all reviews (' + formatReviewCount(displayCount) + ')';
        loadMoreBtn.hidden = !canLoadMore;
        loadMoreBtn.disabled = !!isFetching;
        loadMoreBtn.setAttribute('aria-busy', isFetching ? 'true' : 'false');
      }
    }

    function renderRows(opts) {
      opts = opts || {};
      var filtered = buildDisplayList(allReviews).slice(0, maxReviews);
      if (empty) empty.hidden = filtered.length > 0;
      if (!list) return;
      if (!filtered.length) {
        list.innerHTML = '';
        list.classList.remove('is-updating');
        renderSummary();
        syncLoadUi(0);
        return;
      }
      var slice = filtered.slice(0, visibleCount);
      var hasSkeleton = !!list.querySelector('.crt-row--skeleton');
      var existingRows = list.querySelectorAll('[data-crt-row]:not(.crt-row--skeleton)');
      var already = hasSkeleton ? 0 : existingRows.length;
      var appendOnly = !!opts.appendOnly && !hasSkeleton && already > 0 && already <= slice.length;

      if (appendOnly) {
        var toAdd = slice.slice(already);
        list.classList.remove('is-updating');
        if (toAdd.length) {
          list.insertAdjacentHTML('beforeend', toAdd.map(renderRowHtml).join(''));
          var allRows = list.querySelectorAll('[data-crt-row]');
          for (var i = already; i < allRows.length; i++) {
            allRows[i].style.setProperty('--crt-enter-delay', String((i - already) * 55) + 'ms');
          }
          bindAvatarFallbacks(list);
          syncTextClamps(list);
        }
        renderSummary();
        syncLoadUi(filtered.length);
        return;
      }

      list.innerHTML = slice.map(renderRowHtml).join('');
      list.classList.remove('is-updating');
      list.querySelectorAll('.crt-row--enter').forEach(function (row, index) {
        row.style.setProperty('--crt-enter-delay', String(index * 55) + 'ms');
      });
      bindAvatarFallbacks(list);
      syncTextClamps(list);
      renderSummary();
      syncLoadUi(filtered.length);
    }

    function bindAvatarFallbacks(scope) {
      if (!scope) return;
      scope.querySelectorAll('[data-crt-avatar-img]').forEach(function (img) {
        if (img.dataset.crtAvatarBound === '1') return;
        img.dataset.crtAvatarBound = '1';
        img.addEventListener('error', function () {
          var row = img.closest('.crt-row__avatar');
          if (!row) return;
          var alt = img.getAttribute('alt') || 'Guest';
          var initial = String(alt).trim().charAt(0).toUpperCase() || 'A';
          row.innerHTML = '<span class="crt-row__avatar-fallback" aria-hidden="true">' + escapeHtml(initial) + '</span>';
        });
      });
    }

    function getInitialBatchLimit() {
      return Math.max(rowsPerLoad, visibleCount * 2);
    }

    function fetchAllReviewsBatch() {
      fetchReviews({ workshopTypeKey: '', offset: allReviewsOffset, limit: getInitialBatchLimit() }, function (reviews) {
        var beforeFiltered = filteredReviewCount();
        var beforeLen = allReviews.length;
        appendReviews(shuffleArray(reviews));
        allReviewsOffset += reviews.length;
        hasMoreReviews = reviews.length >= getInitialBatchLimit() && allReviews.length < maxReviews;
        var madeProgress = filteredReviewCount() > beforeFiltered || allReviews.length > beforeLen;
        if (needsMoreInitialReviews() && !madeProgress) hasMoreReviews = false;
        finishBatchOrContinue(madeProgress);
      });
    }

    function fetchNextBatch() {
      if (isFetching || !shopDomain || !hasMoreReviews || allReviews.length >= maxReviews) return;
      isFetching = true;
      syncLoadUi();
      var tabKey = pageWorkshopType || '';
      if (!ownReviewsExhausted && tabKey) {
        fetchReviews({ workshopTypeKey: tabKey, workshopTypeHint: tabKey, offset: ownReviewsOffset, limit: getInitialBatchLimit() }, function (reviews) {
          if (reviews.length < getInitialBatchLimit()) ownReviewsExhausted = true;
          var beforeFiltered = filteredReviewCount();
          var beforeLen = allReviews.length;
          if (reviews.length > 0) {
            appendReviews(shuffleArray(reviews));
            ownReviewsOffset += reviews.length;
          } else {
            ownReviewsExhausted = true;
          }
          var madeProgress = filteredReviewCount() > beforeFiltered || allReviews.length > beforeLen;
          if (ownReviewsExhausted) fetchAllReviewsBatch();
          else finishBatchOrContinue(madeProgress);
        });
        return;
      }
      ownReviewsExhausted = true;
      fetchAllReviewsBatch();
    }

    function maybeApplyFallback() {
      if (buildDisplayList(allReviews).length) return;
      loadFallbackSnapshot(function () {
        if (!allReviews.length && fallbackSnapshot.length) {
          appendReviews(shuffleArray(fallbackSnapshot.slice()));
        }
        renderRows();
      });
    }

    function resetAndFetch() {
      visibleCount = rowsPerLoad;
      ownReviewsExhausted = false;
      allReviewsOffset = 0;
      ownReviewsOffset = 0;
      hasMoreReviews = true;
      isFetching = false;
      allReviews = [];
      seenReviewKeys = {};
      fallbackReviewKeySeq = 0;
      typeScopedAggregateAvg = null;
      shopWideAggregateAvg = null;
      typeScopedAggregateCount = null;
      shopWideAggregateCount = null;
      apiTotalCount = null;
      headerPrimedCount = null;
      headerPrimedAvg = null;
      expandTextStore = {};
      expandTextSeq = 0;
      if (list) {
        list.classList.add('is-updating');
        list.innerHTML = skeletonHtml(Math.min(4, rowsPerLoad));
      }
      syncLoadUi();
      primeHeaderAggregate(fetchNextBatch);
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (isFetching) return;
        var filtered = buildDisplayList(allReviews);
        if (filtered.length > visibleCount) {
          visibleCount = Math.min(visibleCount + rowsPerLoad, maxReviews);
          renderRows({ appendOnly: true });
          return;
        }
        if (!hasMoreReviews || allReviews.length >= maxReviews) return;
        visibleCount = Math.min(visibleCount + rowsPerLoad, maxReviews);
        fetchNextBatch();
      });
    }

    textModalCloseEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeReviewTextModal();
      });
    });

    root.addEventListener('click', function (e) {
      var expandBtn = e.target.closest('[data-crt-expand]');
      if (!expandBtn || !root.contains(expandBtn)) return;
      e.preventDefault();
      e.stopPropagation();
      var row = expandBtn.closest('[data-crt-row]');
      var textEl = row ? row.querySelector('[data-crt-text]') : null;
      if (!textEl) return;
      var expanded = textEl.classList.toggle('is-expanded');
      textEl.classList.toggle('crt-row__text--clamp', !expanded);
      expandBtn.textContent = expanded ? 'Show less' : 'Show more';
      expandBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    window.addEventListener('resize', function () {
      if (!list) return;
      syncTextClamps(list);
    });

    resetAndFetch();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-crt-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-crt-section]').forEach(function (el) {
      delete el.dataset.crtInit;
    });
    boot(e.target);
  });
})();
